module.exports = {
  development: {
    debug: false,
    gaOptions: {
      //userId: insertAuth0IdHere,
      siteSpeedSampleRate: 100
    },
  },
  staging: {
    debug: false,
    gaOptions: {
      //userId: insertAuth0IdHere,
      siteSpeedSampleRate: 100
    },
  },
  production: {
    debug: false,
    gaOptions: {
      //userId: insertAuth0IdHere,
      siteSpeedSampleRate: 100
    },
  },
};
